var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404 d-flex align-items-center h-100 flex-column justify-content-center"},[_c('div',{staticClass:"error404-center"},[_c('h1',[_vm._v("Napaka 404")]),_c('p',[_vm._v("Stran ni bila najdena")]),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Nazaj domov")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }